import { type FC, type ReactNode, useState } from "react";
import { type NavigationConfig } from "../type";
import {
  MobileNavigationOpen,
  MobileNavigationSection,
  MobileNavigationBarItem,
  MobileNavigationBarListItem,
  MobileNavigationMenuButton,
  MobileNavigationAccountSwitcher,
  StyledSection,
  StyledMobilePanel,
  StyledPanelWrapper,
} from "./";
import "@nectary/assets/icons/menu";
import "@nectary/assets/icons/close";

type MobileNavigationProps = {
  MobileProfileItem: FC<{ onClose: () => void }>;
  mobileLogo: ReactNode;
  mobileMessagingConfig: NavigationConfig;
  mobileSettingsConfig: NavigationConfig[number]["subNavigationConfig"];
};
export const MobileNavigation: FC<MobileNavigationProps> = ({
  MobileProfileItem,
  mobileLogo,
  mobileMessagingConfig,
  mobileSettingsConfig,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <>
      {isMenuOpen && (
        <MobileNavigationOpen
          MobileProfileItem={MobileProfileItem}
          onClose={closeMenu}
          messageItems={
            <MobileNavigationSection>
              {mobileMessagingConfig.map((navItem) => {
                const subRoutes = navItem.subNavigationConfig?.flatMap(
                  (section) => section.subRoutes
                );

                if (subRoutes) {
                  return (
                    <MobileNavigationBarItem
                      onClickLink={closeMenu}
                      path={navItem.path}
                      id={navItem.key}
                      key={navItem.key}
                      icon={navItem.icon}
                      label={navItem.label}
                      subPaths={
                        navItem.subNavigationConfig?.flatMap((subConf) =>
                          subConf.subRoutes.map((routes) => routes.href)
                        ) || []
                      }
                      to={navItem.href}
                    >
                      {subRoutes.map((subRoute) => (
                        <MobileNavigationBarListItem
                          withPadding
                          onClick={closeMenu}
                          key={subRoute.href}
                          subRoutes={subRoutes}
                          thisSubRoute={subRoute}
                        />
                      ))}
                    </MobileNavigationBarItem>
                  );
                }

                return (
                  <MobileNavigationBarItem
                    id={navItem.key}
                    path={navItem.path}
                    onClickLink={closeMenu}
                    key={navItem.key}
                    icon={navItem.icon}
                    subPaths={
                      navItem.subNavigationConfig?.flatMap((subConf) =>
                        subConf.subRoutes.map((routes) => routes.href)
                      ) || []
                    }
                    label={navItem.label}
                    to={navItem.href}
                  />
                );
              })}
            </MobileNavigationSection>
          }
          settingsItems={
            <MobileNavigationSection key={"configuration"}>
              {mobileSettingsConfig
                ?.flatMap((section) => section.subRoutes)
                .map((subRoute) => (
                  <MobileNavigationBarListItem
                    onClick={closeMenu}
                    key={subRoute.href}
                    subRoutes={mobileSettingsConfig?.flatMap(
                      (section) => section.subRoutes
                    )}
                    thisSubRoute={subRoute}
                  />
                ))}
            </MobileNavigationSection>
          }
        />
      )}
      <StyledMobilePanel>
        <StyledPanelWrapper>
          <StyledSection>
            <MobileNavigationMenuButton onClick={() => setIsMenuOpen(true)}>
              <sinch-icon-menu
                style={{
                  fontSize: "32px",
                  color: "#000",
                }}
              />
            </MobileNavigationMenuButton>
          </StyledSection>
          <StyledSection align="center">{mobileLogo}</StyledSection>
          <StyledSection align="flex-end">
            <MobileNavigationAccountSwitcher>
              <sinch-icon-close
                style={{
                  fontSize: "32px",
                  color: "#000",
                }}
              />
            </MobileNavigationAccountSwitcher>
          </StyledSection>
        </StyledPanelWrapper>
      </StyledMobilePanel>
    </>
  );
};
